export const TEMPLATE_RULE_CATEGORY = 'rule';
export const TEMPLATE_DEAL_CATEGORY = 'deal';
export const TEMPLATE_ONE_TIME_ACTION_CATEGORY = 'oneTimeAction';
export const SAGA_KEY_TEMPLATES_ADMIN = 'templatesAdmin';

export const CATEGORY_NAME = 'categoryName';
export const CATEGORY_TYPE = 'categoryType';
